// src/components/ui/Button.js
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: ${(props) =>
    props.$variant === 'destructive'
      ? '#474747'
      : props.theme.colors.primaryBlue};
  color: #ffffff;
  padding: 10px 15px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 40px;
  border-radius: 10px;
  font-weight: bold;

  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  transition: background-color 0.2s ease;

  &:hover {
    ${(props) =>
      !props.disabled &&
      `
      background-color: ${props.$variant === 'destructive' ? '#292929' : '#0d1c66'} !important;
      color: #ffffff;
    `}
  }
`;

const Button = ({ disabled, children, onClick, style, variant }) => {
  return (
    <StyledButton
      $variant={variant}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
